<template>
  <div class="caidan">
    <div class="container">
      <!-- 左侧LOGO部分 -->
      <div class="logo-container">
        <img :src="require('@/assets/home/海邻LOGO.png')" alt="海邻LOGO" class="logo" />
<!--        <div class="slogan">-->
<!--          <h1>{{haiLinTitle}}</h1>-->
<!--          <h3>{{haiLinEn}}</h3>-->
<!--        </div>-->
      </div>

      <!-- 导航菜单 -->
      <div class="menu-items" v-if="!isMobile || showMobileMenu">
        <router-link to="/" class="link" exact>{{menuItems[0].title}}</router-link>

        <div v-for="item in menuItems" v-if="item.subItems" :key="item.title" class="menu-container">
          <router-link :to="item.path" class="link" exact>{{ item.title }}</router-link>
          <div class="submenu">
            <template v-for="subItem in item.subItems">
              <div v-if="subItem.subItems" :key="subItem.title" class="menu-item-container">
                <router-link :to="subItem.path" class="menu-item">
                  {{ subItem.title }}
                </router-link>

                <div class="submenu-level-2">
                  <router-link v-for="subSubItem in subItem.subItems"
                              :key="subSubItem.title"
                              :to="subSubItem.path"
                              class="menu-item">
                    {{ subSubItem.title }}
                  </router-link>
                </div>
              </div>
              <router-link v-else
                           :key="subItem.title"
                           :to="subItem.path"
                           class="menu-item">
                {{ subItem.title }}
              </router-link>
            </template>
          </div>
        </div>

        <router-link to="/Contact" class="link">{{menuItems[menuItems.length-1].title}}</router-link>
      </div>
      <div class="rightBox" v-if="!isMobile"></div>

<!--      &lt;!&ndash; 右侧菜单（搜索、语言、登录注册） &ndash;&gt;-->
<!--      <div class="menu-right">-->
<!--        <span class="search-icon" @click="toggleSearch"></span>-->
<!--        <span class="language">&nbsp;{{language}}&nbsp;</span>-->

<!--        <span class="auth"><a href="#">{{dengLu}}</a>&nbsp;|&nbsp;<a href="#">{{zhuCe}}</a></span>&nbsp;-->
        <span class="hamburger-icon" @click="toggleMobileMenu"></span>

<!--      </div>-->
<!--      &lt;!&ndash; 搜索框 &ndash;&gt;-->
<!--      <div v-if="showSearch" class="search-container">-->
<!--        <input type="text" class="search-input" v-model="searchQuery" placeholder="请输入搜索内容" />-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'caidan',
  data() {
    return {
      showSearch: false,
      searchQuery: "",
      showMobileMenu: false,
      topBarIcon:'@/assets/log.png',
      haiLinTitle:'新型饲用蛋白供应商',
      haiLinEn:'NEW FEED PROTEIN SUPPLIER',
      language:'En',
      dengLu:'登录',
      zhuCe:'注册',
      menuItems: [

        { title: '首页', path: '/' },

        { title: '关于海邻', path: '/About', subItems: [
            { title: '企业简介', path: '/About' },
            { title: '发展历程', path: '/History' },
            { title: '企业荣誉', path: '/Corporatehonors' },
            { title: '企业文化', path: '/Corporateculture' },

          ]},
        { title: '产品中心', path: '/Product', subItems: [
            { title: '产朊假丝酵母蛋白', path: '/Product/ProductCandidaYeast/pig', subItems: [
              { title: '猪', path: '/Product/ProductCandidaYeast/pig' },
              { title: '禽', path: '/Product/ProductCandidaYeast/chicken' },
              { title: '水产', path: '/Product/ProductCandidaYeast/fish' }
            ]},
            { title: '酿酒酵母培养物', path: '/Product/ProductGrainWineYeast/pig', subItems: [
              { title: '猪', path: '/Product/ProductGrainWineYeast/pig' },
              { title: '禽', path: '/Product/ProductGrainWineYeast/chicken' },
              { title: '反刍', path: '/Product/ProductGrainWineYeast/cattle' }
            ]},
            { title: '含可溶物的玉米干酒精糟', path: '/Product/ProductCornDryAlcohol/pig', subItems: [
              { title: '猪', path: '/Product/ProductCornDryAlcohol/pig' },
              { title: '禽', path: '/Product/ProductCornDryAlcohol/chicken' },
              { title: '反刍', path: '/Product/ProductCornDryAlcohol/cattle' }
            ]},
            { title: '其他', path: '/Product/Other',subItems: [
                { title: '肉鸭', path: '/Product/Other' },
                { title: '肉鹅', path: '/Product/Other' },

              ] }
          ]},
        { title: '技术中心', path: '/Research', subItems: [

            { title: '技术团队', path: '/Research/team' },
            { title: '技术力量', path: '/Research/power' },
            { title: '研究内容', path: '/Research/content' },
            { title: '技术成果', path: '/Research/achievements' },
            { title: '质量管理', path: '/Research/quality' }
          ]},
        { title: '海邻动态', path: '/Dynamic/company', subItems: [
            { title: '公司动态', path: '/Dynamic/company' },
            { title: '媒体报道', path: '/Dynamic/media' },
            { title: '视频中心', path: '/Dynamic/video' }
          ]},
        { title: '人才中心', path: '/Talent', subItems: [
            { title: '加入我们', path: '/Talent' },
            { title: '人才体系', path: '/Talent/system' }
          ]},
        { title: '联系我们', path: '/Contact/NewMap' }
      ]
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  methods: {
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },

  }
};
</script>
<style scoped>
html, body {
  width: 100%;
  max-width: 1920px;
  display: flex;
  justify-content: center;

}
 .caidan {
  width: 100%;
  overflow: visible;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9990;
  font-family: 'SourceHanSansCN', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #333333;
  font-weight: normal;
  font-display: swap;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.rightBox{
  width: 20%;
  height: 100px;
}

@font-face {
  font-family: 'SourceHanSansCN';
  src: url('../font/SourceHanSansCN-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.container {
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;
  height: 100px;
  box-sizing: border-box;
  z-index: 1;

}
.logo-container {
  width:400px;
  display: flex;
  align-items: center;
  font-family: 'SourceHanSansCN', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  margin-left: 40px;
}
.logo {
  width: 400px;
  margin-left: 20px;
  margin-right: 10px;
  margin-top: -3px;
}
.slogan h1 {
  font-size: 19px;
  line-height: 1;
  color: #333333;
  font-weight: normal;
  font-family: 'SourceHanSansCN', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', 'PingFang SC', sans-serif;
}
.slogan h3 {
  font-size: 12px;
  color: #333333;
  font-family: 'SourceHanSansCN', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-weight: 400;
}

.menu-items {
  padding: 0 20px;
  display: flex;
  color: #333333;
  justify-content: right;
  flex: 1;
  margin-left: 5%;

}

.link {
  text-decoration: none;
  color: #333333;
  font-size: 16px;
  padding: 0 30px;
  margin: 0;
  height: 100px;
  line-height: 60px;
  font-weight: normal;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  width: auto;
  text-align: center;
}
@media screen and (max-width: 1300px){
  .link {
    padding: 0 10px;
  }
}
@media screen and (max-width: 900px){
  .link {
    padding: 0 5px;
  }
}
/* 修改激活状态的样式 */
.link.router-link-active.router-link-exact-active {
  /*color: white;
  background-color: #00a0fa;*/
}

.link:hover {
  color: white;
  background-color: #00a0fa;
}

/* 子菜单 */

.menu-container {
  align-items: center;
  position: relative;
  z-index: 9998;
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #71c856;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  transform: translateZ(0);
}

.menu-container:hover .submenu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.menu-item {
  position: relative;
  text-decoration: none;
  display: flex;
  color: white;
  width: 100%;

  justify-content: center;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 14px;
  text-align: center;
  transition: all 0.3s ease;
  background-color: #71c856;
}

.menu-item:hover {
  background-color: #00a0fa;
}

.menu-item-container {
  position: relative;
  width: 100%;
}

.submenu-level-2 {
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 120px;
  background-color: #71c856;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  z-index: 10000;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
}

/* 修改这里，让所有产品的二级菜单都显示在右侧 */
.menu-item-container:hover > .submenu-level-2,
.menu-item-container:hover > .menu-item + .submenu-level-2 {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.menu-item-container:hover > .menu-item {
  background-color: #00a0fa;
}

/* 当子菜单显示时，保持父菜单的激活状态 */
.menu-container:hover .link,
.menu-container .submenu:hover ~ .link {
  color: white;
  background-color: #00a0fa;
}

/* ========== 右侧菜单 ========== */

.menu-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-icon {
  width: 1.2vw;
  height: 1.2vw;
  background: url('@/assets/about/search@2x.png') no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

.language {
  font-size: 1.3vw;
  font-weight: bold;
  cursor: pointer;
  margin-left: 1vw;
  color: #333333;
}

.menu-right auth {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth a {
  text-decoration: none;
  color: #333333;
  font-size: 12px;
  margin-left: 1vw;
}

.auth a:hover {
  color: #333333;
}


/* 搜索框样式 */

.search-container {
  position: absolute; /* 设置为绝对定位 */
  top: 100%; /* 紧接在菜单栏下面 */
  left: 0; /* 从左侧开始 */
  right: 0; /* 到右侧结束 */
  background: white;
  padding: 0.5vw;
  box-shadow: 0 0.4vw 0.6vw rgba(0, 0, 0, 0.1);
  border-radius: 0.5vw;
  z-index: 9999;
}

/* 搜索框输入框样式 */

.search-input {
  width: 100%; /* 使输入框占满搜索框的宽度 */
  padding: 0.5vw;
  font-size: 1vw;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
}


.hamburger-icon {
  display: none;
  width: 40px;
  height: 40px;
  background: url('@/assets/about/hanbaobao.png') no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

/* 公司简介区域 */

.company-intro {
  width: 100%;
  height: auto;
  padding: 5vw 10vw;
  position: relative;
  overflow: hidden;
  background: white;
  position: relative;
}

.company-intro::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 40%;
  height: 80%;
  background: linear-gradient(135deg, #0099ff 0%, #3DBB3D 100%);
  z-index: 1;
  clip-path: polygon(100% 0, 0% 100%, 100% 100%);
}

.main-title {
  font-size: 5vw;
  font-weight: bold;
  color: #0099ff;
  text-align: left;
  line-height: 1.2;
  margin-bottom: 1vw;
  position: relative;
  z-index: 2;
}

.sub-title {
  font-size: 2vw;
  color: #666;
  text-align: left;
  margin-bottom: 4vw;
  position: relative;
  z-index: 2;
}

.company-stats {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5vw;
  width: 100%;
  position: relative;
  z-index: 2;
}

.stat-item {
  display: flex;
  align-items: center;
  margin-right: 3vw;
}

.stat-label {
  font-size: 1.2vw;
  color: #666;
  margin-right: 1vw;
}

.stat-divider {
  width: 1px;
  height: 30px;
  background-color: #ccc;
  margin: 0 1vw;
}

.stat-value {
  font-size: 3vw;
  font-weight: bold;
  color: #0099ff;
  margin-right: 0.5vw;
}

.stat-unit {
  font-size: 1.2vw;
  color: #666;
}

.learn-more {
  text-align: left;
  margin-bottom: 2vw;
  position: relative;
  z-index: 2;
}

.learn-more a {
  font-size: 1.2vw;
  color: #0099ff;
  text-decoration: none;
  display: inline-block;
}

.pagination {
  display: flex;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
}

.page-item {
  font-size: 1vw;
  color: #999;
  margin-right: 1vw;
}

.page-item.active {
  color: #666;
  font-weight: bold;
}



@media (min-width: 769px) and (max-width: 1700px) {
  .container {
    /*padding: 0 20px;*/
  }

  .logo-container {
    width: 300px;
    margin-left: 26px;
  }

  .logo {
    width: 300px;
  }

  .menu-items {
    padding: 0 10px;
    justify-content: flex-end;
  }


  @media screen and (max-width:1240px){

  }
@media screen and (max-width:1000px){

}
  .menu-item {
    font-size: 14px;
    height: 50px;
  }

  .submenu-level-2 {
    min-width: 100px;
  }
}

@media (max-width: 768px) {

  .container {
    flex-wrap: wrap;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    font-size: 20px;
    position: relative;
    justify-content: space-evenly;
    align-items: center;
    background-color: #fff;
    width: 100%;
    z-index: 1;
  }

  .logo-container {
    width: 250px;
    display: flex;
    align-items: center;
    font-family: 'Microsoft YaHei', sans-serif;
  }

  .logo {
    width: 300px;
    margin-left: -22%;
    margin-top: -3px;
  }

  .slogan h1 {
    font-size: 16px;
  }

  .slogan h3 {
    font-size: 10px;
  }

  .search-container {
    position: absolute; /* 设置为绝对定位 */
    top: 100%; /* 紧接在菜单栏下面 */
    left: 0; /* 从左侧开始 */
    right: 30%; /* 到右侧结束 */
    background: white;
    padding: 0.5vw;
    box-shadow: 0 0.4vw 0.6vw rgba(0, 0, 0, 0.1);
    border-radius: 0.5vw;
    z-index: 9999;
  }

  .search-input {
    width: 100%; /* 使输入框占满搜索框的宽度 */
    padding: 10px;
    font-size: 1vw;
    border: 1px solid #ccc;
    border-radius: 5px;
    outline: none;
    z-index: 8888;
  }

  .link {
    width: 100%;
    height: 50px;
    padding: 0;
    margin: 0;
    text-align: center;
    justify-content: center;
    background: #f5f5f5;
    border-bottom: 1px solid #eee;
  }

  .link:hover {
    background-color: #e8e8e8;
    color: #00a0fa;
  }

  .menu-container:hover > .link,
  .menu-container:hover .submenu:hover > .link {
    color: black;
    width: 100%;
    height: 50px;
    background: whitesmoke;
  }

  .menu-items {
    flex-direction: column;
    width: 50%;
    height: auto;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    margin-right:0;
    padding: 0;
    background-color: white;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    opacity: 0.9;
    transition: opacity 0.3s ease;
    max-height: calc(80vh - 60px);
    overflow-y: auto;
  }

  .hamburger-icon {
    display: block;
    width: 30px;
    height: 30px;
  }

  .submenu, .submenu-level-2 {
    position: static;
    width: 100%;
    opacity: 1;
    visibility: visible;
    box-shadow: none;
  }

  .menu-item-container {
    position: static;
  }

  .menu-item {
    height: 50px;
    font-size: 14px;
    background-color: #f5f5f5;
    color: #333;
    border-bottom: 1px solid #ddd;
  }

  .menu-item:hover {
    background-color: #e0e0e0;
    color: #333;
  }
}

.dropdown-item {
  text-decoration: none;
  color: inherit;
  display: block;
  padding: 10px 20px;
  transition: background-color 0.3s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

:global(body) {
  padding-top: 90px;
}

@media (max-width: 768px) {
  :global(body) {
    padding-top: 60px;
  }

  .caidan {
    width: 100%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 10vw;
  }

  .menu-items {
    position: fixed;
    top: 100px;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    opacity: 1;
    transition: opacity 0.3s ease;
    max-height: calc(80vh - 60px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: 0;
  }
}
@media screen and (max-width: 5000px) and (min-width: 769px) {
  .caidan {
    position: static;
  }
  .menu-items {
    padding: 0 ;
  }
  :global(body) {
    padding-top: 0;
  }
}
@media (min-width: 1920px) {
  .rightBox{
    width:378px;
    height: 100px;
  }
}

</style>
